import {SET_USER_DATA, RESET_USER_PHOTO,
        SET_NOTIFICATIONS, READ_NOTIFICATIONS} from '../constants/user';
import userAPI, { cancelRequest } from '../../_api/user';
import { decrementNotificationsCount, getAuthUserData } from './auth';
import { getDifficultyList, getTonalityList } from './shop';
import { reset, stopSubmit, SubmissionError } from 'redux-form';

export const setUserData = (data) => ({ type: SET_USER_DATA, data });
export const resetUserPhoto = () => ({ type: RESET_USER_PHOTO });

const setNotifications = (list) => ({ type: SET_NOTIFICATIONS, list });
const readNotifications = (ids) => ({ type: READ_NOTIFICATIONS, ids });

export const getUserData = (userSlug) => async (dispatch) => {
  const response = await userAPI.getUserData(userSlug);
  if (response) {
    dispatch(setUserData(response));
    return response;
  }
};

export const updateUserData = (payload) => async (dispatch) => {
  const response = await userAPI.updateUserData(payload);
  if (response) dispatch(setUserData(response));
};

export const deleteUserPhoto = () => async (dispatch) => {
  const response = await userAPI.deleteUserPhoto();
  if (response) dispatch(resetUserPhoto());
};

export const uploadUserPhoto = (payload) => async (dispatch) => {
  const response = await userAPI.uploadUserPhoto(payload);
  if (response) dispatch(setUserData(response));
};

export const getNotifications = () => async (dispatch) => {
  const response = await userAPI.getNotifications();
  if (response) dispatch(setNotifications(response));
};

export const makeReadNotifications = (ids) => async (dispatch) => {
  if (ids.length){
    try {
      if (cancelRequest !== undefined) cancelRequest();
      const response = await userAPI.makeReadNotifications(ids);
      if (response){
        dispatch(readNotifications(ids));
        dispatch(decrementNotificationsCount(ids.length));
      }
    }
    catch (e) {}
    finally {}
  }
};

export const userLogin = (payload) => async (dispatch) => {
  const response = await userAPI.userLogin(payload);
  if (response) {
    // получение данных об авторизации и общих данных о пользователе
    dispatch(getAuthUserData());
    // получение списка "Сложность" из магазина
    dispatch(getDifficultyList());
    // получение списка "Тональность" из магазина
    dispatch(getTonalityList());
    dispatch(reset('loginForm'));
  }
};

export const changeUserPassword = (payload) => async (dispatch) => {
  const response = await userAPI.changePassword(payload);
  dispatch(reset('passwordForm'));
  return response;
};

